export default __webpack_public_path__ + "static/media/how-it-works_1.bde80fd5.png";